import * as React from "react";
import { EventContact } from "src/api/events/event.types";

interface SpeakerContactSectionProps {
  contacts?: EventContact[];
}

const SpeakerContactSection: React.FC<SpeakerContactSectionProps> = ({ contacts = [] }) => (
  <div className="d-flex flex-column gap-2">
    {contacts.map((contact: EventContact, idx: number) => (
      <div key={contact.id || idx} className="d-flex align-items-center gap-2">
        <span
          className="icon icon-lg border-radius-circle bg-light d-flex align-items-center justify-content-center"
          style={{ width: 50, height: 50, flexShrink: 0, aspectRatio: "1 / 1" }}
        >
          person
        </span>
        <div className="d-flex flex-column">
          <span className="fs-14 fw-medium">{contact.friendlyName}</span>
          <span className="fs-14 fw-medium text-secondary">
            {contact.jobTitle !== "N/A" ? `${contact.jobTitle} - ${contact.accountName}` : contact.accountName}
          </span>
        </div>
      </div>
    ))}
  </div>
);

export default SpeakerContactSection;
